<template>
  <div
    class="insights-widget-summary d-flex flex-wrap gap-20"
    :class="{ loading: isLoading }"
  >
    <div v-if="userView">
      <transition-group
        name="slide"
        tag="div"
        class="widget-wrapper confidence-panels-container"
      >
        <div
          v-for="level in filteredLevels"
          :key="level.key"
          class="confidence-panel"
        >
          <div class="value text-32 z-text-gray-900">
            <span>{{ level.count }}</span>
            <span class="small line-tight"> {{ level.count | pluralize('Instance', 'Instances') }}</span>
          </div>
          <InsightsUnusualActivityConfidenceBadge :confidence-level="level.index" />
        </div>
      </transition-group>
    </div>
    <div v-if="!userView">
      <div class="widget-wrapper min-w-18rem">
        <div class="value text-32 z-text-gray-900">
          <span>{{ totalMembers }}</span>
        </div>
        <div class="text-14 z-text-gray-600">{{ totalMembers | pluralize('Member', 'Members') }}</div>
      </div>
    </div>
    <div v-if="!userView">
      <div class="widget-wrapper min-w-18rem">
        <div class="value text-32 z-text-gray-900">
          <span>{{ totalInstances }}</span>
        </div>
        <div class="text-14 z-text-gray-600">
          {{ totalInstances | pluralize('Instance', 'Instances') }}
        </div>
      </div>
    </div>
    <div>
      <div class="widget-wrapper min-w-18rem">
        <div class="value text-32 z-text-gray-900">
          <span>{{ formattedTotalTime }}</span>
        </div>
        <div class="text-14 z-text-gray-600 d-inline-flex align-items-center no-wrap">Total time (h:m)</div>
      </div>
    </div>
    <div v-if="userView">
      <div class="widget-wrapper min-w-18rem">
        <div class="value text-32 z-text-gray-900">
          <span>{{ formattedPreviousDaysTotalTime }}</span>
        </div>
        <div class="text-14 z-text-gray-600 d-inline-flex align-items-center no-wrap">Previous 60 days (h:m)</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { secondsToHours } from '~/utils/time_utils';
import { INSIGHTS_CONFIDENCE_LEVELS } from '~/app_constants';
import InsightsUnusualActivityConfidenceBadge from '~/components/insights/InsightsUnusualActivityConfidenceBadge.vue';

export default {
  name: 'InsightsUnusualActivityWidgetSummary',
  components: { InsightsUnusualActivityConfidenceBadge },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    previousDaysTotalDuration: {
      type: Number,
      default: 0,
    },
    totalMembers: {
      type: Number,
      default: 0,
    },
    totalInstances: {
      type: Number,
      default: 0,
    },
    totalInstancesByConfidenceLevels: {
      type: Object,
      default: () => {},
    },
    totalDuration: {
      type: Number,
      default: 0,
    },
    userView: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapState(['filters']),
    formattedTotalTime() {
      return secondsToHours((this.totalDuration || 0) * 60);
    },
    formattedPreviousDaysTotalTime() {
      return secondsToHours((this.previousDaysTotalDuration || 0) * 60);
    },
    levels() {
      return [...INSIGHTS_CONFIDENCE_LEVELS]
        .map(({ key, name, color, lightColor }, index) => ({
          key,
          name,
          color,
          lightColor,
          index,
          count: parseInt(this.totalInstancesByConfidenceLevels?.[key] || 0, 10),
        }))
        .reverse(); // show High first
    },
    filteredLevels() {
      const selected = this.filters?.confidence_levels;

      if (Array.isArray(selected) && selected.length) {
        return this.levels.filter((l) => selected.includes(l.key));
      }

      return this.levels;
    },
  },
};
</script>
